import React, { useEffect } from 'react';
import { Link } from '@uhg-abyss/web/ui/Link';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { styled } from '@uhg-abyss/web/tools/styled';
import { LagoonContext } from '@src/AppContext';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { config } from '@uhg-abyss/web/tools/config';

const Wrapper = styled('div', {
  paddingLeft: '100px',
});

const StledHeading = styled(Heading, {
  marginTop: '127px',
  marginBottom: '30px',
});

const List = styled('ul', {
  fontWeight: 'bold',
});

const Level1 = styled('li', { marginBottom: '20px' });
const Level2 = styled('li', {
  marginLeft: '25px',
  marginBottom: '14px',
  listStyleType: 'disc',
});
const Level3 = styled('li', {
  marginLeft: '50px',
  marginBottom: '14px',
  listStyleType: 'disc',
});
const Level4 = styled('li', {
  marginLeft: '75px',
  marginBottom: '14px',
  listStyleType: 'disc',
});

const levelComponentMap = { Level1, Level2, Level3, Level4 };

export const SiteMap = () => {
  useEffect(() => {
    // Dynatrace page tagging
    const dtrum = window?.dtrum;
    if (dtrum) {
      dtrum.setPage({
        name: 'apimarketplace:site-map',
        group: `apimarketplace-${config('APP_ENV')}`,
      });
    }
  }, []);

  const lagoonContext = React.useContext(LagoonContext);
  const allSitemapData = lagoonContext?.getTable('sitemap')?.getRow();
  const activeSitemapData = allSitemapData?.filter((data) => {
    return data.active;
  });

  const StyledLink = styled(Link, {
    display: 'flex',
    fontSize: '15px !important',
  });

  const { navigate } = useRouter();

  const renderLink = (item) => {
    if (item.anchor) {
      return (
        <a
          href={item.path}
          rel="noreferrer"
          target={item.newTab ? '_blank' : '_self'}
        >
          {item.label}
        </a>
      );
    }
    return (
      <StyledLink
        onClick={(e) => {
          navigate(item.path);
        }}
      >
        <span style={{ fontWeight: 'bold' }}>{item.label}</span>
      </StyledLink>
    );
  };

  const renderSitemap = (data, mapToId) => {
    const filteredData = data?.filter((item) => {
      return item.mapToId === mapToId;
    });
    const sortedData = filteredData?.sort((a, b) => {
      if (a.class === 'Level1' || b.class === 'Level2') {
        return a.priority - b.priority;
      }
      if (a.class === 'Level3' || a.class === 'Level4') {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
      }
      return 0;
    });

    return (
      <React.Fragment>
        {sortedData?.map((item) => {
          const LevelComponent = levelComponentMap[item.class] || 'li';
          return (
            <React.Fragment>
              <LevelComponent key={item.id}>{renderLink(item)}</LevelComponent>
              {data.some((child) => {
                return child.mapToId === item.id;
              }) && <List>{renderSitemap(data, item.id)}</List>}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  };

  return (
    <Wrapper>
      <StledHeading display={4}>Sitemap</StledHeading>
      <List>{renderSitemap(activeSitemapData)}</List>
    </Wrapper>
  );
};
